import { Table } from '@mantine/core';

import { paymentTypeTypes } from '../../types';

import { BodyRow } from './BodyRow';

type PaymentTypesTableProps = {
  paymentTypes: paymentTypeTypes.PaymentType[];
};

export function PaymentTypesTable({ paymentTypes }: PaymentTypesTableProps) {
  return (
    <Table stickyHeader striped highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Название</Table.Th>
          <Table.Th>Ключ</Table.Th>
          <Table.Th>Формат оплаты</Table.Th>
          <Table.Th>Действия</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {paymentTypes?.map((paymentType) => (
          <BodyRow key={paymentType._id} paymentType={paymentType} />
        ))}
      </Table.Tbody>
    </Table>
  );
}
